module.exports = __webpack_public_path__ + "img/Yellow-L-2@2x.87cdd275.png";